export const UTILS = {
    makeMaxLengthError: (maxLength: number) => ({value: maxLength, message: `Must be ${maxLength} characters or less`}),
    minLengthError: (length: number) => ({value: length, message: `Must be ${length} characters`})
}
